module.exports = __webpack_public_path__ + "img/logo.7b78777e.png";